// extracted by mini-css-extract-plugin
export default {"askQuestion":"AskQuestion_askQuestion__D66fq","input":"AskQuestion_input__q-vK-"};